/* eslint no-use-before-define: 0  */
import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper'
import Countdown from 'react-countdown'
import BuyModal from './BuyModal'

import 'swiper/scss'
import 'swiper/scss/navigation'
import 'swiper/scss/pagination'

const LiveAuction = (props) => {
    const data = props.data

    const [modalShow, setModalShow] = useState(false)

    return (
        <Fragment>
            <section className="tf-section live-auctions">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="heading-live-auctions">
                                <h2 className="tf-title pb-20">Popular Items</h2>
                                <Link to="/marketplace" className="exp style2">
                                    EXPLORE MORE
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <Swiper
                                modules={[Navigation, Pagination, Scrollbar, A11y]}
                                spaceBetween={30}
                                breakpoints={{
                                    0: {
                                        slidesPerView: 1,
                                    },
                                    767: {
                                        slidesPerView: 2,
                                    },
                                    991: {
                                        slidesPerView: 3,
                                    },
                                    1300: {
                                        slidesPerView: 4,
                                    },
                                }}
                                navigation
                                pagination={{ clickable: true }}
                                scrollbar={{ draggable: true }}
                            >
                                {data.slice(0, 7).map((item, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="swiper-container show-shadow carousel auctions">
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide">
                                                    <div className="slider-item">
                                                        <div className="sc-card-product menu_card style-h7">
                                                            <div className="meta-info style">
                                                                <Link
                                                                    to="#"
                                                                    className="wishlist-button available"
                                                                ></Link>
                                                                <Link to="#" className="wishlist-button lock"></Link>
                                                            </div>
                                                            <div className="card-media">
                                                                <Link to="/item-details-01">
                                                                    <img src={item.img} alt="Axies" />
                                                                </Link>
                                                            </div>
                                                            <div className="card-title">
                                                                <h6>
                                                                    <Link to="item-details.html">{item.title}</Link>
                                                                </h6>
                                                                <div className="phase">
                                                                    <span className="pricing">{item.phase}</span>
                                                                </div>
                                                            </div>
                                                            <div className="meta-info">
                                                                <div className="author">
                                                                    <div className="info">
                                                                        <span className="pricing">{item.tags}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="author">
                                                                    <div className="info">
                                                                        <span className="pricing">
                                                                            {item.item_float}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="meta-info">
                                                                <div className="author">
                                                                    <div className="info">
                                                                        <span>Price</span>
                                                                        <span className="pricing">{item.price}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="discount-percent">
                                                                    -{item.discount}%
                                                                </div>
                                                            </div>
                                                            <div className="card-bottom">
                                                                <button
                                                                    onClick={() => setModalShow(true)}
                                                                    className="sc-button style bag fl-button pri-3 no-bg"
                                                                >
                                                                    <span></span>
                                                                </button>
                                                                <button
                                                                    onClick={() => setModalShow(true)}
                                                                    className="sc-button fl-button pri-3 no-bg"
                                                                >
                                                                    <span>Buy Now</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>
            <BuyModal show={modalShow} onHide={() => setModalShow(false)} />
        </Fragment>
    )
}

LiveAuction.propTypes = {
    data: PropTypes.array.isRequired,
}

export default LiveAuction
